import React, { createContext, SetStateAction, useContext, useState } from "react";

export interface News {
  nrcode: string;
  startdate: string;
  title: string;
  linkaddress: string;
  check: number;
}

interface NewsContextType {
  news: News[];
  setNews: React.Dispatch<SetStateAction<News[]>>;
}

const NewsContext = createContext<NewsContextType | undefined>(undefined);

export const NewsProvider = ({children}: {children: React.ReactNode}) => {
  const [news, setNews] = useState<News[]>([]);

  return (
    <NewsContext.Provider
      value={{
        news,
        setNews,
      }}
    >
      {children}
    </NewsContext.Provider>
  );
};

export const useNewsContext = () => {
  const context = useContext(NewsContext);
  if (context === undefined) {
    throw new Error("useNewsContext must be used within a NewsProvider");
  }
  return context;
};
